import GroupMetric, { GroupMetricStrings } from 'enums/GroupMetric'
import SocialWebChannelType, { SocialWebChannelTypeStrings } from 'enums/SocialWebChannelType'

export const metricTranslations = {
  [GroupMetric.FOLLOWERS]: 'follower_other',
  [GroupMetric.BRAND_POSTS]: 'brandPost_other',
  [GroupMetric.ENGAGEMENTS]: 'engagement_other',
  [GroupMetric.COMMENTS]: 'comment_other',
  [GroupMetric.SHARES]: 'share_other',
  [GroupMetric.LIKES]: 'like_other',
  [GroupMetric.VIEWS]: 'view_other',
  [GroupMetric.FOLLOWERS_BY_POSTS]: 'followersByPosts',
  [GroupMetric.ENGAGEMENT_RATE]: 'engagementRate',
  [GroupMetric.CONVERSATION_RATE]: 'conversationRate',
  [GroupMetric.AMPLIFICATION_RATE]: 'amplificationRate',
  [GroupMetric.APPLAUSE_RATE]: 'applauseRate',
  [GroupMetric.VIEW_RATE]: 'viewRate',
  [GroupMetric.ENGAGEMENT_RATE_PER_FOLLOWERS]: 'engagementRatePerFollowers',
  [GroupMetric.CONVERSATION_RATE_PER_FOLLOWERS]: 'conversationRatePerFollowers',
  [GroupMetric.AMPLIFICATION_RATE_PER_FOLLOWERS]: 'amplificationRatePerFollowers',
  [GroupMetric.APPLAUSE_RATE_PER_FOLLOWERS]: 'applauseRatePerFollowers',
  [GroupMetric.VIEW_RATE_PER_FOLLOWERS]: 'viewRatePerFollowers'
}

export const metricOrders = [
  GroupMetric.FOLLOWERS,
  GroupMetric.BRAND_POSTS,
  GroupMetric.ENGAGEMENTS,
  GroupMetric.COMMENTS,
  GroupMetric.SHARES,
  GroupMetric.LIKES,
  GroupMetric.VIEWS,
  GroupMetric.FOLLOWERS_BY_POSTS,
  GroupMetric.ENGAGEMENT_RATE,
  GroupMetric.CONVERSATION_RATE,
  GroupMetric.AMPLIFICATION_RATE,
  GroupMetric.APPLAUSE_RATE,
  GroupMetric.VIEW_RATE,
  GroupMetric.ENGAGEMENT_RATE_PER_FOLLOWERS,
  GroupMetric.CONVERSATION_RATE_PER_FOLLOWERS,
  GroupMetric.AMPLIFICATION_RATE_PER_FOLLOWERS,
  GroupMetric.APPLAUSE_RATE_PER_FOLLOWERS,
  GroupMetric.VIEW_RATE_PER_FOLLOWERS
]

export const SHARES_METRICS: GroupMetricStrings[] = [
  GroupMetric.SHARES,
  GroupMetric.AMPLIFICATION_RATE,
  GroupMetric.AMPLIFICATION_RATE_PER_FOLLOWERS
]

export const SHARES_METRICS_SUPPORTED_CHANNELS: SocialWebChannelTypeStrings[] = [
  SocialWebChannelType.TWITTER,
  SocialWebChannelType.FACEBOOK,
  SocialWebChannelType.TIKTOK
]

export const VIEWS_METRICS: GroupMetricStrings[] = [
  GroupMetric.VIEWS,
  GroupMetric.VIEW_RATE,
  GroupMetric.VIEW_RATE_PER_FOLLOWERS
]

export const VIEWS_METRICS_SUPPORTED_CHANNELS: SocialWebChannelTypeStrings[] = [
  SocialWebChannelType.YOUTUBE,
  SocialWebChannelType.TIKTOK,
  SocialWebChannelType.TWITTER
]

export const METRICS_WITH_TOTAL: GroupMetricStrings[] = [
  GroupMetric.BRAND_POSTS,
  GroupMetric.ENGAGEMENTS,
  GroupMetric.LIKES,
  GroupMetric.SHARES,
  GroupMetric.COMMENTS,
  GroupMetric.FOLLOWERS,
  GroupMetric.VIEWS
]

export const groupTitleTranslations = {
  [SocialWebChannelType.TWITTER]: 'twitter',
  [SocialWebChannelType.FACEBOOK]: 'facebook',
  [SocialWebChannelType.YOUTUBE]: 'youTube',
  [SocialWebChannelType.INSTAGRAM]: 'instagram',
  [SocialWebChannelType.TIKTOK]: 'tikTok',
  [SocialWebChannelType.OTHER]: 'other'
}

export const AVATAR_DIAMETER = '32px'

export const metricTooltipTranslations = {
  [GroupMetric.FOLLOWERS]: 'groupMetricTooltip.followers',
  [GroupMetric.BRAND_POSTS]: 'groupMetricTooltip.brandPosts',
  [GroupMetric.ENGAGEMENTS]: 'groupMetricTooltip.engagements',
  [GroupMetric.COMMENTS]: 'groupMetricTooltip.comments',
  [GroupMetric.SHARES]: 'groupMetricTooltip.shares',
  [GroupMetric.LIKES]: 'groupMetricTooltip.likes',
  [GroupMetric.VIEWS]: 'groupMetricTooltip.views',
  [GroupMetric.FOLLOWERS_BY_POSTS]: 'groupMetricTooltip.followersByPosts',
  [GroupMetric.ENGAGEMENT_RATE]: 'groupMetricTooltip.engagementRate',
  [GroupMetric.CONVERSATION_RATE]: 'groupMetricTooltip.conversationRate',
  [GroupMetric.AMPLIFICATION_RATE]: 'groupMetricTooltip.amplificationRate',
  [GroupMetric.APPLAUSE_RATE]: 'groupMetricTooltip.applauseRate',
  [GroupMetric.VIEW_RATE]: 'groupMetricTooltip.viewRate',
  [GroupMetric.ENGAGEMENT_RATE_PER_FOLLOWERS]: 'groupMetricTooltip.engagementRatePerFollowers',
  [GroupMetric.CONVERSATION_RATE_PER_FOLLOWERS]: 'groupMetricTooltip.conversationRatePerFollowers',
  [GroupMetric.AMPLIFICATION_RATE_PER_FOLLOWERS]:
    'groupMetricTooltip.amplificationRatePerFollowers',
  [GroupMetric.APPLAUSE_RATE_PER_FOLLOWERS]: 'groupMetricTooltip.applauseRatePerFollowers',
  [GroupMetric.VIEW_RATE_PER_FOLLOWERS]: 'groupMetricTooltip.viewRatePerFollowers'
}

export const multiLineHeaders: GroupMetricStrings[] = [
  GroupMetric.ENGAGEMENT_RATE_PER_FOLLOWERS,
  GroupMetric.CONVERSATION_RATE_PER_FOLLOWERS,
  GroupMetric.AMPLIFICATION_RATE_PER_FOLLOWERS,
  GroupMetric.APPLAUSE_RATE_PER_FOLLOWERS,
  GroupMetric.VIEW_RATE_PER_FOLLOWERS
]
